





























import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import utils from '@/services/utils';

@Component
export default class RoundModalDetail extends Vue {
  @Prop() readonly roundSelect!: any;

  utilsInstance = utils;
}
